import { FC, memo, useMemo } from "react";
import { useGetRequirementsByTypeQuery } from "graphql/__generated__/hooks";
import { Requirement } from "types/requirement";
import { ListWithEntitySelector } from "components/ListWithEntitySelector";
import { REQUIREMENT } from "helpers/constants";

type RelatedCompetencySkillsProps = {
  competencySkills: Requirement[];
  onChange: (value: Requirement[]) => void;
  label?: string;
};

export const RelatedCompetencySkillsComponent: FC<
  RelatedCompetencySkillsProps
> = ({ competencySkills, onChange, label = "Related Competency Skills" }) => {
  const { data } = useGetRequirementsByTypeQuery({
    variables: { reqType: REQUIREMENT.REQUIREMENT_COMPETENCY },
  });

  const competencies = useMemo(() => {
    return data?.requirement || [];
  }, [data]);

  return (
    <ListWithEntitySelector
      label={label}
      elements={competencySkills}
      onChangeElements={(selected) => onChange(selected)}
      idField={"requirement_id"}
      entityName={"Competency Skills"}
      displayFieldSecondary={"requirement_type"}
      entityList={competencies}
    />
  );
};

export const RelatedCompetencySkills = memo(RelatedCompetencySkillsComponent);
